import { NessProductListType } from '../../App/Plus/Product/S/Constant/product.js';
import { makeMenuHref } from '../../Util/S/Function/util.js';
import { STORE_PRODUCT_CUSTOM_LEVEL } from '../../../Creator/Product/S/constant.js';
import { isLabsOpened } from '../../../NessLabs/S/Function/deploy.js';

export const NESS_CUSTOM_PRODUCT_LIST_URL = makeMenuHref(NessProductListType.custom, 'kr');
export const NESS_CUSTOM_ASSET_PRODUCT_LIST_URL = `/kr/@/product/list/custom`;

const NESS_CUSTOM_LABS_ROUTER_SUBPATH = () => (isLabsOpened() ? 'labs' : 'labs-anatole');
export const NESS_CUSTOM_LABS_ROUTER = () => `/product/list/${NESS_CUSTOM_LABS_ROUTER_SUBPATH()}`;
export const NESS_CUSTOM_USER_PRODUCT_LIST_URL = () => `/kr/@${NESS_CUSTOM_LABS_ROUTER()}`;

const OLD_BANNER_IMAGE = {
  img_url: '//s3.marpple.co/files/u_29089/2024/12/original/48d8734eb8596e0995b148dc47fb77c1ee1e49882.png',
  img_url_mo: '//s3.marpple.co/files/u_29089/2024/12/original/ec60d08ee61c4ad256d07a2a7e003928512f9e001.png',
};

const NEW_BANNER_IMAGE = {
  img_url: '//s3.marpple.co/files/u_29089/2025/1/original/232c5c99fe178dcc39690ba128a0a4056cec86d22.png',
  img_url_mo: '//s3.marpple.co/files/u_29089/2025/1/original/4918cf0088d5648f748eacfd04460dfd0311a2ea1.png',
};

const LABS_BANNER_IMAGES = () => {
  return isLabsOpened() ? NEW_BANNER_IMAGE : OLD_BANNER_IMAGE;
};

export const CUSTOM_STUDIO = () => ({
  title: isLabsOpened() ? 'Custom Studio' : 'My MapleStory',
  custom_level: STORE_PRODUCT_CUSTOM_LEVEL.ASSET,
  img_url: '//s3.marpple.co/files/u_2798351/2025/6/original/c8e6f6ae2cb35c6126fa232b3e37fc2e2ae7fc681.png',
  img_url_mo: '//s3.marpple.co/files/u_2798351/2025/6/original/0cf975539d950eaea716d5c48ac61bc89af9d1aa1.png',
  link_url: NESS_CUSTOM_ASSET_PRODUCT_LIST_URL,
  is_disabled: false,
});

export const LABS = () =>
  Object.assign(
    {
      title: 'LABS',
      custom_level: STORE_PRODUCT_CUSTOM_LEVEL.USER,
      link_url: NESS_CUSTOM_USER_PRODUCT_LIST_URL(),
      is_disabled: !isLabsOpened(),
    },
    LABS_BANNER_IMAGES(),
  );

export const NESS_CUSTOM_HARDCODING = () => ({
  maplestory: {
    menu_name_kr: '마이 메이플스토리',
    menu_name_en: 'My MapleStory',
    is_show_home_list: false,
    is_show_banner: true,
    custom_banners: isLabsOpened() ? [LABS(), CUSTOM_STUDIO()] : [CUSTOM_STUDIO(), LABS()],
  },
});
